import axios from "axios";

export default {
  namespaced: true,
  state: {
    tenants: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    tenantsMessage: ''
  },
  mutations: {
    RECEIVED_TENANTS(state, payload) {
      state.tenants = payload;
      state.isReceiving = false;
    },
    RECEIVING_TENANTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TENANT(state, payload) {
      state = Object.assign(state, {
        tenants: [...state.tenants, payload],
        isReceiving: false,
      })
    },
    RECEIVING_TENANT(state) {
      state.isReceiving = true;
    },
    UPDATED_TENANT(state, payload) {
      let index = state.tenants.findIndex(tenant => tenant._id === payload._id);
      state = Object.assign(state, {
        tenants: state.tenants.map((tenant, i) => {
          if (i === index) {
            return Object.assign({}, tenant, payload);
          }
          return tenant;
        }),
        isUpdating: false,
        tenantsMessage: 'Tenants has been updating!',
      })
    },
    UPDATING_TENANT(state) {
      state.isUpdating = true;
    },
    DELETED_TENANT(state, payload) {
      let indexToDelete = state.tenants.findIndex(tenant => tenant._id === payload._id);
      let tenants = [...state.tenants];
      tenants.splice(indexToDelete, 1);
      state = Object.assign(state, {
        tenants: [...tenants],
        isDeleting: false,
        idToDelete: null,
        tenantsMessage: 'Tenant has been Deleted!',
      });
    },
    DELETING_TENANT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertTenantRequest({dispatch}, payload) {
      dispatch("receivingTenant");
      let  token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/tenant';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveTenant", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertTenantWithImageRequest({dispatch}, payload) {
      dispatch("receivingTenant");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/tenant/withimage';
      let data = new FormData();
      data.append('image', payload.tenantimage, payload.imagename); 
      delete payload['tenantimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveTenant", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async deleteTenantRequest({dispatch}, payload) {
      console.log("H", payload)
      dispatch("deletingTenant", payload);
      return axios.delete('https://api.accountxc.com:3100/delete/tenant/' + payload._id)
      .then(() => {
        dispatch("deleteTenant", {_id: payload._id});
      })
    },
    async getTenantsRequest({dispatch}) {
      dispatch("receivingTenants");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/tenants';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: headers})
      .then(response => {
        dispatch("receiveTenants", response.data);
      })
    },
    async findTenantsQueryRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("receivingTenants");
        let token = localStorage.getItem('token');
        console.log(payload)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/tenants/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveTenants", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateTenantRequest({dispatch}, payload) {
      dispatch("updatingTenant");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/tenant/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      try {
        let response = await axios({method: 'put', url: url, headers: headers, data: payload});
        dispatch("updateTenant", response.data);
        return response.data;
      } catch (error) {
        console.error('Error:', error);
        this.alertmessage = error;
      }
    },
    updateTenantImageRequest({dispatch}, payload) {
      dispatch("updatingTenant");
      let data;
      let headers;
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/tenant/image/' + id;
      data = new FormData();
      data.append('image', payload.tenantimage, payload.imagename); 
      delete payload['tenantimage'];
      for (let x in payload) {data.append(x, payload[x])}
      headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      axios({method: "PUT", url: url, headers: headers, data: data})
      .then( (response)=> {
        dispatch("updateTenant", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    receiveTenants({commit}, payload) {
      commit("RECEIVED_TENANTS", payload)
    },
    receivingTenants({commit}) {
      commit("RECEIVING_TENANTS")
    },
    receiveTenant({commit}, payload) {
      commit("RECEIVED_TENANT", payload)
    },
    receivingTenant({commit}) {
      commit("RECEIVING_TENANT")
    },
    updateTenant({commit}, payload) {
      commit("UPDATED_TENANT", payload)
    },
    updatingTenant({commit}) {
      commit("UPDATING_TENANT")
    },
    deleteTenant({commit}, payload) {
      commit("DELETED_TENANT", payload)
    },
    deletingTenant({commit}, payload) {
      commit("DELETING_TENANT", payload)
    }
  },
};
